import React from 'react';
import { Pie } from 'react-chartjs-2';
import * as XLSX from 'xlsx';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const CustomerPieChart = () => {
    const customerGroups = [
        { age_group: "-", customer_count: 46 },
        { age_group: "0-4", customer_count: 85 },
        { age_group: "20-24", customer_count: 3 },
        { age_group: "25-29", customer_count: 5 },
        { age_group: "30-34", customer_count: 2 },
        { age_group: "35-39", customer_count: 1 },
        { age_group: "45-49", customer_count: 1 },
        { age_group: "50-54", customer_count: 1 },
        { age_group: "5-9", customer_count: 1 },
    ];

    const data = {
        labels: customerGroups.map(group => group.age_group),
        datasets: [
            {
                label: 'Customer Count',
                data: customerGroups.map(group => group.customer_count),
                backgroundColor: [
                    '#F8A81B', '#00AB9A', '#91B7D9', '#FF6384', '#36A2EB',
                    '#FFCE56', '#FF9F40', '#4BC0C0', '#9966FF'
                ],
                hoverBackgroundColor: [
                    '#F8A81B', '#00AB9A', '#91B7D9', '#FF6384', '#36A2EB',
                    '#FFCE56', '#FF9F40', '#4BC0C0', '#9966FF'
                ],
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'right',
                align: 'center',
                labels: {
                    boxWidth: 20,
                    padding: 20,
                    usePointStyle: true,
                    color: '#333',
                },
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        return `${tooltipItem.label}: ${tooltipItem.raw}`;
                    },
                },
            },
        },
    };

    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(customerGroups);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Customer Age Groups");
        XLSX.writeFile(workbook, "Customer_Age_Group_Distribution.xlsx");
    };

    return (
        <div className="w-full bg-white rounded-lg h-full p-4">
            <div className="flex justify-between items-center mb-2">
                <p className="text-[17px] font-medium text-primary">Age Group Distribution</p>
                <button
                    onClick={exportToExcel}
                    className="bg-primary text-white px-4 py-1.5 rounded-md text-[14px] transition"
                >
                    Export
                </button>
            </div>
            <Pie data={data} options={options} />
        </div>
    );
};

export default CustomerPieChart;
